<template>
  <div class="monitoring-cabin-container">
    <v-pane-person-info name="轨迹报表"></v-pane-person-info>
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group class="mr-10">
          <el-button @click="getData" size="mini" type="primary" icon="el-icon-search">查询
          </el-button>
          <el-button @click="reset" size="mini" type="primary" icon="el-icon-refresh">重置</el-button>
          <el-button @click="download" size="mini" type="primary" icon="el-icon-download">导出
          </el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15">
        <div class="item">
          <div class="span">姓名</div>
          <el-input v-model="obj.txt11" placeholder="请输入姓名" size="mini"></el-input>
        </div>
        <div class="item">
          <div class="span">工号</div>
          <el-input v-model="obj.txt11" placeholder="请输入工号" size="mini"></el-input>
        </div>
        <div class="item">
          <span class="span">人员状态</span>
          <el-select size="mini" v-model="obj.select11" placeholder="请选择部门">
            <el-option
              v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
              :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="span">起止时间</span>
          <el-date-picker size="mini" class="date-time" v-model="obj.dates" type="datetimerange"
            range-separator="到" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </div>
      </div>
    </div>

    <div class="table mt-15">
      <el-table v-loading="tableLoading" border ref="table" :data="list" highlight-current-row
        @current-change="handleCurrentChange" style="width:100%">
        <el-table-column label="序号">1</el-table-column>
        <el-table-column label="姓名"></el-table-column>
        <el-table-column label="工号"></el-table-column>
        <el-table-column label="识别卡号"></el-table-column>
        <el-table-column label="基站名称"></el-table-column>
        <el-table-column label="进入时间"></el-table-column>
        <el-table-column label="离开时间"></el-table-column>
        <el-table-column label="停留时间"></el-table-column>
      </el-table>
    </div>

    <div class="pagination pt-10 t-center">
      <el-pagination background layout="total,sizes,prev,pager,next,jumper"
        :page-size="pagination.size" :page-sizes="[10,20,30,50]"
        :current-page.sync="pagination.page" :total="pagination.total" @size-change="changeSize"
        @current-change="changeCurrent"></el-pagination>
    </div>

    <el-dialog :title="currentRow?'编辑':'新建'" width="400px" :visible.sync="addDialogShow">
      <div class="add-box">
        <div class="o-hidden">
          <span class="span">名称</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden">
          <span class="span">名称</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addDialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import { tool } from "../../common/js/tool.js";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      obj: {
        txt: "",
        txt11: "",
        select: "",
        select11: "",
        date: "",
        datas: "",
        dateTime: "",
        number: ""
      },
      list: [],
      currentRow: null,
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      tableLoading: false,
      addobj: { name: "" },
      addDialogShow: false
    };
  },

  computed: {},

  created() {
    this.getData();
  },

  methods: {
    download() {
      let loadingInstance = Loading.service({
        fullscreen: true,
        text: "数据生成中"
      });
      setTimeout(() => {
        loadingInstance.close();
      }, 1000);
    },
    clickAdd() {
      this.addDialogShow = true;
      this.currentRow = null;
    },
    clickEdit() {
      if (!this.currentRow) {
        tool.message("请在表格中选择数据", "error");
        return;
      }
      this.addDialogShow = true;
    },
    del() {
      if (!this.currentRow) {
        tool.message("请在表格中选择数据", "error");
      } else {
        this.$confirm("确定要删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$message({
            type: "success",
            duration: 1000,
            message: "操作成功!",
            onClose: () => {
              this.getData();
            }
          });
        });
      }
    },
    submit() {
      console.log(this.addobj);
      this.addDialogShow = false;
    },
    getData(flag) {
      let obj = Object.assign({}, this.obj);
      obj.page = flag ? this.pagination.page : 1;
      this.pagination.page = flag ? this.pagination.page : 1;
      console.log(this.obj, this.pagination, obj);
      this.tableLoading = true;
      this.tableLoading = false;
      this.pagination.total = 222;
      this.list = [
        { id: 1 },
        { id: 2 },
        { id: 3 },
        { id: 4 },
        { id: 5 },
        { id: 6 },
        { id: 7 },
        { id: 8 },
        { id: 9 },
        { id: 10 }
      ];
    },
    reset() {
      this.obj.page = 1;
      this.pagination.page = 1;
      this.getData();
    },
    changeCurrent(val) {
      this.pagination.page = val;
      this.obj.page = val;
      this.getData(true);
    },

    changeSize(e) {
      this.pagination.size = e;
      this.obj.pageSize = e;
      this.getData();
    },
    handleCurrentChange(val) {
      this.currentRow = val;
      //console.log(val.id);
    }
  },

  components: {}
};
</script>

<style lang="less" rel="stylesheet/less">
.monitoring-cabin-container {
  width: 100%;
  height: auto;
  display: flex;
  align-items: stretch;
  padding: 15px;
  flex-direction: column;
}
</style>
